import { render } from "./listPersonDownloadFich.vue?vue&type=template&id=d73f6e5c"
import script from "./listPersonDownloadFich.vue?vue&type=script&lang=js"
export * from "./listPersonDownloadFich.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__